import { createRegistry } from "@/lib/content/registry";

// HRMS content registry.
// To add an HRMS page: create a file in ./features (or ./solutions), import it
// here, and add it to the array below. The catch-all route does the rest
// (URL, SEO, rendering, sitemap).
import { absenceManagement } from "./features/absence-management";
import { attendanceDashboard } from "./features/attendance-dashboard";
import { comprehensiveReporting } from "./features/comprehensive-reporting";
import { geofencingAttendance } from "./features/geofencing-attendance";
import { overtimeMonitoring } from "./features/overtime-monitoring";
import { realTimeAttendanceTracking } from "./features/real-time-attendance-tracking";
import { shiftManagement } from "./features/shift-management";
import { attendanceTracking } from "./features/attendance-tracking";
import { employeeDirectory } from "./features/employee-directory";
import { employeeShiftManagement } from "./features/employee-shift-management";
import { leaveManagement } from "./features/leave-management";
import { payrollIntegration } from "./features/payroll-integration";
import { performanceReview } from "./features/performance-review";
import { expenseManagement } from "./features/expense-management";
import { leaveAccrualDetails } from "./features/leave-accrual-details";
import { leaveApproval } from "./features/leave-approval";
import { leaveBalance } from "./features/leave-balance";
import { leaveDashboard } from "./features/leave-dashboard";
import { leaveHistory } from "./features/leave-history";
import { leavePolicyAllocation } from "./features/leave-policy-allocation";
import { leaveReports } from "./features/leave-reports";
import { leaveRequests } from "./features/leave-requests";
import { leaveTypes } from "./features/leave-types";
import { automatedSalaryCalculation } from "./features/automated-salary-calculation";
import { customDeductions } from "./features/custom-deductions";
import { integrationWithAccounting } from "./features/integration-with-accounting";
import { overtimeLeaveCalculations } from "./features/overtime-leave-calculations";
import { payslipGeneration } from "./features/payslip-generation";
import { taxAndComplianceManagement } from "./features/tax-and-compliance-management";
import { candidateCommunication } from "./features/candidate-communication";
import { interviewManagement } from "./features/interview-management";
import { multiPlatformJobPosting } from "./features/multi-platform-job-posting";
import { reportingAndAnalytics } from "./features/reporting-and-analytics";
import { resumeParsing } from "./features/resume-parsing";
import { bpoKpo } from "./solutions/bpo-kpo";
import { caFirm } from "./solutions/ca-firm";
import { cpaFirm } from "./solutions/cpa-firm";
import { csFirm } from "./solutions/cs-firm";
import { lawFirm } from "./solutions/law-firm";
import { realEstate } from "./solutions/real-estate";

export const hrmsContent = createRegistry(
  [
    absenceManagement,
    attendanceDashboard,
    comprehensiveReporting,
    geofencingAttendance,
    overtimeMonitoring,
    realTimeAttendanceTracking,
    shiftManagement,
    attendanceTracking,
    employeeDirectory,
    employeeShiftManagement,
    leaveManagement,
    payrollIntegration,
    performanceReview,
    expenseManagement,
    leaveAccrualDetails,
    leaveApproval,
    leaveBalance,
    leaveDashboard,
    leaveHistory,
    leavePolicyAllocation,
    leaveReports,
    leaveRequests,
    leaveTypes,
    automatedSalaryCalculation,
    customDeductions,
    integrationWithAccounting,
    overtimeLeaveCalculations,
    payslipGeneration,
    taxAndComplianceManagement,
    candidateCommunication,
    interviewManagement,
    multiPlatformJobPosting,
    reportingAndAnalytics,
    resumeParsing,
    bpoKpo,
    caFirm,
    cpaFirm,
    csFirm,
    lawFirm,
    realEstate,
  ],
  { basePath: "/hrms-software" }
);
